import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import avatarPlaceholder from '../../../assets/images/mock/default-profile-icon.png'
import SmallMilestoneIcon from '../../common/SmallMilestoneIcon'
import { ReactComponent as XIcon } from '../../../assets/images/common/icons/X-icon.svg'
import { ReactComponent as DragIcon } from '../../../assets/images/common/icons/drag-icon.svg'
import { ReactComponent as MessageIcon } from '../../../assets/images/common/icons/Message.svg'
import { GENDER_LABEL_KEYS } from '../../../utility/userHelper'
import Tooltip from '../../common/Tooltip'
import styles from './Studentcard.module.scss'
import classNames from 'classnames'
import colors from '../../../assets/styles/globals.scss'

const RSVP_STATUS_LABEL_KEYS = {
  created: 'events.common.noResponse',
  confirmed: 'events.common.attending',
  declined: 'events.common.notAttending',
  waitlisted: 'events.common.waitlisted',
}

const STATUS_COLOR = {
  created: colors.lightNavy,
  confirmed: colors.darkTeal,
  declined: colors.redDarker,
  waitlisted: colors.blue,
}

const StudentCard = ({ student, dragging, removeStudent, dragged, listeners, attributes }) => {
  const { t } = useTranslation()

  return (
    <div className={classNames(
      'd-flex align-items-center',
      styles.studentCard,
      dragged && styles.dragged,
      !dragging && !dragged && styles.drag,
      dragging && styles.dragging)}
    >
      <div className='d-flex align-items-center w-100' {...listeners} {...attributes} data-tip={dragged && student.note}>
        <Tooltip/>
        <DragIcon className={styles.dragIcon}/>
        {(student.note && !dragging && dragged) ?
          <MessageIcon data-tip={student.note} data-tip-disable={false} className={styles.messageIconDragged}/>
          : null
        }
        <div
          className={classNames('d-flex flex-column justify-content-center', styles.studentData)}
        >
          <div className='d-flex align-items-center'>
            <div className='mr-3 smaller-round-image-wrapper' >
              <img
                alt={t('events.pairings.studentCard.avatarAlt')}
                className='round-image'
                src={student.avatar?.fileUrl || avatarPlaceholder}
              />
            </div>
            <SmallMilestoneIcon fromAvatar className={styles.studentLevel} division={student.currentFormalDivision} />
            <div>
              <p className={styles.studentTitle}>{student.firstName} {student.lastName}</p>
              <p className={styles.studentInfo}>
                {t('events.pairings.studentCard.ageGender', { age: student.age, gender: t(GENDER_LABEL_KEYS[student.gender]) })}
              </p>
              <p className={styles.studentStatus} style={{ color: STATUS_COLOR[student.status] }}>
                {t(RSVP_STATUS_LABEL_KEYS[student.status])} {student.status === 'waitlisted' && ` #${student.waitlistOrder}`}
              </p>
            </div>
          </div>
          {(student.note && !dragging && !dragged) ?
            <div className={classNames('d-flex align-items-center', styles.studentNoteWrapper)}>
              <MessageIcon data-tip={student.note} data-tip-disable={false} className={styles.messageIcon}/>
              <p className={styles.studentNote}>{student.note}</p>
            </div> : null
          }
        </div>
      </div>
      <XIcon className={classNames('pull-right', styles.removeStudentButton)} onClick={removeStudent}/>
    </div>
  )
}

StudentCard.propTypes = {
  student: PropTypes.object.isRequired,
  dragging: PropTypes.bool,
  dragged: PropTypes.bool,
  listeners: PropTypes.object,
  attributes: PropTypes.object,
  removeStudent: PropTypes.func,
}

export default StudentCard
